import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { ReactComponent as HubIcon } from '../../../assets/Icons/hub-icon.svg';
import { useQuery } from '@apollo/client';
import { GetHubCheckInsDocument } from '@sandtech-hub-monorepo/ehub-client';
import { formatDate as formatDateFns } from 'date-fns';
import {
  AdvancedTable,
  Button,
  Dialog,
  useIsMobile,
} from '@sandtech-hub-monorepo/ui-kit';
import { formatDate, formatDateTime } from '../../../dateFormat';
import { Link } from 'react-router-dom';
import { AppRoutesPaths } from '../../../../../../../apps/central-hub/src/routes/types';

export const ProgramEnrollmentAttendance = () => {
  const mobile = useIsMobile();
  const [lastVisitsOpen, setLastVisitsOpen] = useState(false);
  const { data } = useQuery(GetHubCheckInsDocument, {
    variables: {
      pageNumber: 1,
      pageSize: 5,
      checkInDateSortOrder: 'desc',
      checkInStartDate: formatDateFns(
        new Date(
          Date.now() - (new Date().getDay() - 1) * 24 * 60 * 60 * 1000 * 1000
        ),
        'yyyy-MM-dd'
      ),
      checkInEndDate: formatDateFns(new Date(), 'yyyy-MM-dd'),
    },
  });

  const date = new Date();
  date.setHours(0, 0, 0);

  return (
    <>
      <div className="flex flex-wrap gap-1 items-center text-sm text-foreground font-medium">
        <HubIcon className="text-popover-foreground" height={16} width={16} />
        <b>Hub Attendance:</b>
        <span>
          You have attended hubs{' '}
          <span className="text-primary">
            {data?.viewer.hubCheckIns?.totalCount || 0} times
          </span>{' '}
          this week.
          {!!data?.viewer.hubCheckIns?.totalCount && (
            <span
              className="inline-flex gap-1 align-center ml-1 text-primary hover:border-primary border-b border-transparent cursor-pointer"
              onClick={() => setLastVisitsOpen(true)}
            >
              See details here <ChevronRight size={20} />
            </span>
          )}
        </span>
      </div>
      <Dialog
        open={lastVisitsOpen}
        onOpenChange={setLastVisitsOpen}
        title={`Your last ${Math.min(
          data?.viewer.hubCheckIns?.totalCount || 5,
          5
        )} hub visits`}
      >
        <AdvancedTable
          entries={(data?.viewer.hubCheckIns?.hubCheckIns || []).map((d) => ({
            id: d?.createdAt,
            ...d,
          }))}
          pageSize={5}
          columns={[
            {
              cell: ({ checkedInAt }) => formatDate(checkedInAt),
              name: 'Date',
              key: 'date',
            },
            {
              cell: ({ hub }) => hub?.name,
              name: 'Name of hub',
              key: 'hub',
            },
            mobile
              ? null
              : {
                  cell: ({ checkedInAt }) => formatDateTime(checkedInAt),
                  name: 'Checked-In',
                  key: 'checkIn',
                },
            mobile
              ? null
              : {
                  cell: ({ checkedOutAt }) =>
                    checkedOutAt ? formatDateTime(checkedOutAt) : '-',
                  name: 'Checked-Out',
                  key: 'checkOut',
                },
            {
              cell: ({ checkedInAt, checkedOutAt }) => {
                if (!checkedOutAt) {
                  return '-';
                }

                const d =
                  date.valueOf() +
                  new Date(checkedOutAt).valueOf() -
                  new Date(checkedInAt).valueOf();

                return (
                  formatDateFns(d, 'H') +
                  ' hrs ' +
                  formatDateFns(d, 'm') +
                  ' min'
                );
              },
              name: 'Time at hub',
              key: 'time',
            },
          ]}
        />
        <Link to={AppRoutesPaths.HubAttendance} className="mx-auto mt-4">
          <Button variant="outline">View all hub visits</Button>
        </Link>
      </Dialog>
    </>
  );
};
